import { createSelector } from "reselect";
import i18n from "src/translations";
import { hasUnlockWoundRevisionsPermissionSelector } from "src/selectors/ui_config_selectors/patients";

export function createUnlockTooltipSelector() {
  return createSelector(
    hasUnlockWoundRevisionsPermissionSelector,
    canUnlockWound => {
      const missingPermissionsText = i18n.t(
        "text.revisionButtonTooltips.missingPermissions"
      );
      return !canUnlockWound ? missingPermissionsText : "";
    }
  );
}
